<template>
  <div>
    <div class="mb-24 flex items-center gap-x-8">
      <h3 class="heading-3 w-1/2">
        {{ titles.title1 }}
      </h3>
      <h3 class="heading-3 w-1/2">
        {{ titles.title2 }}
      </h3>
    </div>

    <div
      class="text-static-default-low body-1 relative grid grid-cols-2 gap-x-8"
    >
      <IconReassuranceCertified
        alt=""
        class="text-static-default-hi absolute left-1/4 top-[-12px] ml-[-16px]"
        size="24"
      />
      <RevIllustration
        alt=""
        class="absolute right-1/4 top-[-12px] mr-[-16px]"
        :height="24"
        src="/img/product/new-battery/ThunderIcon.svg"
        :width="24"
      />

      <p
        v-for="(paragraph, index) in paragraphs"
        :key="index"
        class="bg-static-default-mid flex items-center justify-center p-16"
        :class="{
          [tw`rounded-t-md pt-24`]: index === 0 || index === 1,
          [tw`rounded-b-md pb-24`]: index === 4 || index === 5,
        }"
      >
        {{ paragraph }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { tw } from '@backmarket/utils/string/tw'
import { RevIllustration } from '@ds/components/Illustration'
import { IconReassuranceCertified } from '@ds/icons/IconReassuranceCertified'

import { PC_LAPTOPS, ProductCategory } from '~/scopes/product-core/constants'

import translations from './ComparisonArea.translations'

const i18n = useI18n()

const props = defineProps<{
  brand: string
  categoryId: string
}>()

const titles = computed(() => ({
  title1: i18n(translations.section1Item1Title),
  title2: i18n(translations.section1Item2Title),
}))

const isSmartphone = computed(() => {
  return props.categoryId === ProductCategory.SMARTPHONE
})

const isLaptop = computed(() => {
  return PC_LAPTOPS.includes(props.categoryId)
})

const paragraphs = computed(() => {
  if (isLaptop.value) {
    return [
      i18n(translations.section1Item1Paragraph1Laptop),
      i18n(translations.section1Item2Paragraph1),
      i18n(translations.section1Item1Paragraph2),
      i18n(translations.section1Item2Paragraph2),
      i18n(translations.section1Item1Paragraph3),
      i18n(translations.section1Item2Paragraph3),
    ]
  }

  if (isSmartphone.value) {
    return [
      i18n(translations.section1Item1Paragraph1),
      i18n(translations.section1Item2Paragraph1),
      i18n(translations.section1Item1Paragraph2),
      i18n(translations.section1Item2Paragraph2),
      i18n(translations.section1Item1Paragraph3),
      i18n(translations.section1Item2Paragraph3),
    ]
  }

  return [
    i18n(translations.section1Item1Paragraph1Others),
    i18n(translations.section1Item2Paragraph1),
    i18n(translations.section1Item1Paragraph2),
    i18n(translations.section1Item2Paragraph2),
    i18n(translations.section1Item1Paragraph3),
    i18n(translations.section1Item2Paragraph3),
  ]
})
</script>
